import Vue from 'vue'

class Persist {
  prePersist () {
    console.log('pre persist called')

    delete this.attrs._id
    delete this.attrs.slug
    delete this.attrs.created_at
    delete this.attrs.updated_at
    delete this.attrs.show
  }

  postPersist () {
    console.log('post persist called')
  }

  preCreate () {
    console.log('pre create called')
  }

  postCreate () {
    console.log('post create called')
  }

  preUpdate () {
    console.log('pre update called')
  }

  postUpdate () {
    console.log('post update called')
  }

  preRemove () {
    console.log('pre remove called')
  }

  postRemove () {
    console.log('post remove called')
  }

  async save () {
    let endpoint = `${this.api.url}${this.api.endpoints.save}`

    this.preCreate()
    this.prePersist()

    let res = await Vue.prototype.$http.post(endpoint, this.attrs)

    this.postPersist()
    this.postCreate()

    return res
  }

  async update () {
    let endpoint = `${this.api.url}${this.api.endpoints.update}/${this.attrs._id}`

    this.preUpdate()
    this.prePersist()

    let res = await Vue.prototype.$http.put(endpoint, this.attrs)

    this.postPersist()
    this.postUpdate()

    return res
  }

  async delete () {
    let endpoint = `${this.api.url}${this.api.endpoints.delete}/${this.attrs._id}`

    this.preRemove()
    this.prePersist()

    let res = await Vue.prototype.$http.delete(endpoint)

    this.postPersist()
    this.postRemove()

    return res
  }
}

export default Persist
